import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const pushSupported = () =>
  "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

export const isStandalone = () =>
  window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;

export const isIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

const urlBase64ToUint8Array = (base64String) => {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};

// "on" (subscribed) | "off" | "denied" | "unsupported" | "ios-needs-install"
export async function getPushState() {
  if (!pushSupported()) return "unsupported";
  if (Notification.permission === "denied") return "denied";
  if (isIOS() && !isStandalone()) return "ios-needs-install";
  try {
    const reg = await navigator.serviceWorker.getRegistration("/sw.js");
    if (!reg) return Notification.permission === "granted" ? "off" : "off";
    const sub = await reg.pushManager.getSubscription();
    return sub ? "on" : "off";
  } catch (_) {
    return "off";
  }
}

export async function enablePush(token) {
  if (!pushSupported()) return { ok: false, reason: "unsupported" };
  if (isIOS() && !isStandalone()) return { ok: false, reason: "ios-needs-install" };
  const perm = await Notification.requestPermission();
  if (perm !== "granted") return { ok: false, reason: "denied" };
  try {
    const reg = await navigator.serviceWorker.register("/sw.js");
    const { data } = await axios.get(`${API}/push/public-key`, { headers: { Authorization: `Bearer ${token}` } });
    const sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(data.publicKey),
    });
    await axios.post(`${API}/push/subscribe`, sub.toJSON(), { headers: { Authorization: `Bearer ${token}` } });
    return { ok: true };
  } catch (e) {
    return { ok: false, reason: "error" };
  }
}

export async function disablePush(token) {
  try {
    const reg = await navigator.serviceWorker.getRegistration("/sw.js");
    const sub = reg ? await reg.pushManager.getSubscription() : null;
    if (sub) {
      await axios.post(`${API}/push/unsubscribe`, { endpoint: sub.endpoint }, { headers: { Authorization: `Bearer ${token}` } });
      await sub.unsubscribe();
    }
    return { ok: true };
  } catch (_) {
    return { ok: false };
  }
}
